<template>
  <div class="pmi-image-container">
    <img
      v-if="paymentMethod.bank_account"
      class="bank-img"
      src="@shared/assets/img/payment/bank.png"
      alt="Bank Account"
    >
    <img
      v-else-if="paymentMethod?.card?.brand === 'visa'"
      class="card-img"
      src="@shared/assets/img/payment/visa-icon.png"
      alt="Visa"
    >
    <img
      v-else-if="paymentMethod?.card?.brand === 'mastercard'"
      class="card-img"
      src="@shared/assets/img/payment/master-icon.png"
      alt="Mastercard"
    >
    <img
      v-else-if="paymentMethod?.card?.brand === 'american_express'"
      class="card-img"
      src="@shared/assets/img/payment/amex-icon.png"
      alt="American Express"
    >
    <img
      v-else-if="paymentMethod?.card?.brand === 'discover'"
      class="card-img"
      src="@shared/assets/img/payment/discover-icon.png"
      alt="Discover"
    >
    <img
      v-else-if="paymentMethod?.card"
      class="card-img"
      src="@shared/assets/img/payment/card-icon.png"
      alt="Credit Card"
    >
  </div>
</template>

<script>
export default {
  name: 'PaymentMethodIcon',
  props: {
    paymentMethod: Object,
  },
};
</script>

<style lang="scss" scoped>
.pmi-image-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  
  .card-img {
    height: 35px;
  }
}
</style>
